import React from 'react'
import { Button, Modal } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { formatDateTimeAmericaBogota } from '@auteco/utils/dateToLocal'

/**
 * Componente que muestra la información del material y sus botones de acción
 */
const MaterialInfoCard = ({ 
  material, 
  idUser, 
  isAuditor,
  isReadOnly,
  onClose, 
  onSave, 
  onLiberar 
}) => {
  if (!material.estado) return null

  const codigoEspejoSap =
    material.repuesto_espejo_de_codigo_sap != null &&
    String(material.repuesto_espejo_de_codigo_sap).trim() !== ''
      ? String(material.repuesto_espejo_de_codigo_sap).trim()
      : null

  const codigoEspejoASap =
    material.repuesto_espejo_a_codigo_sap != null &&
    String(material.repuesto_espejo_a_codigo_sap).trim() !== ''
      ? String(material.repuesto_espejo_a_codigo_sap).trim()
      : null

  return (
    <>
      {/* Header con botón de cerrar */}
      <div className="material-header">
        <Button
          className="close-button"
          type="text"
          icon={<CloseOutlined />}
          disabled={false}
          onClick={() => onClose?.()}
        />
      </div>

      {/* Tarjeta de información del material */}
      <div className="material-info-card">
        <div className="material-info-header">
          <div className="material-code">
            <div className="material-code-line">
              <span className="label">Material:</span>
              <span className="value">{material.repuesto_codigo_material_sap}</span>
            </div>
            {codigoEspejoSap && (
              <div className="material-code-line">
                <span className="label">Espejo de:</span>
                <span className="value">{codigoEspejoSap}</span>
              </div>
            )}
            {codigoEspejoASap && (
              <div className="material-code-line">
                <span className="label">Espejo a:</span>
                <span className="value">{codigoEspejoASap}</span>
              </div>
            )}
          </div>
          <div className="material-status">
            <span className="label">Estado:</span>
            <span className={`status-badge status-${material.estado.toLowerCase().replace(/\s+/g, '-')}`}>
              {material.estado}
            </span>
          </div>
        </div>

        {/* Información del revisor */}
        {material.revision_nombre_revisor && (
          <div className="reviewer-info">
            <div className="reviewer-details">
              <span className="label">Revisado por:</span>
              <span className="value">{material.revision_nombre_revisor}</span>
            </div>
            {material.revision_fecha_creacion && (
              <div className="review-date">
                <span className="date">
                  {formatDateTimeAmericaBogota(material.revision_fecha_creacion)}
                </span>
              </div>
            )}
          </div>
        )}

        {/* Información del auditor */}
        {material.revision_nombre_auditor && (
          <div className="auditor-info">
            <span className="label">Auditor:</span>
            <span className="value">{material.revision_nombre_auditor}</span>
          </div>
        )}

        {/* Botones de acción */}
        <div className="action-buttons">
          {(isAuditor || material.estado !== 'REVISADO')  && (
            <Button
              className="save-button"
              type="primary"
              icon="💾"
              onClick={onSave}
              size="small"
              disabled={isReadOnly}
            >
              Guardar 
            </Button>
          )}
          
          {!isAuditor &&
            idUser === material.revision_usuario_revisor_id &&
            (material.estado === 'ASIGNADO' || material.estado === 'REASIGNADO') && (
              <Button
                className="release-button"
                type="primary"
                onClick={() => {
                  Modal.confirm({
                    title: '¿Estás seguro de liberar este material?',
                    onOk: () => {
                      onLiberar()
                    }
                  })
                }}
                size="small"
                disabled={isReadOnly}
              >
                Liberar
              </Button>
            )}
          
          {isAuditor && (
            <Button
              className="release-button"
              type="primary"
              onClick={onLiberar}
              size="small"
              disabled={isReadOnly}
            >
              Liberar 
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

export default MaterialInfoCard

